import React from "react";
import { ChevronLeft } from "lucide-react";

import { Button } from "@/components/ui/button";

import { cn } from "@/lib/utils";

function SwiperNav({
  swiper,
  prevNavRef,
  nextNavRef,
  navIcon = ChevronLeft,
  iconClassName,
  className,
}) {
  React.useEffect(() => {
    if (swiper && swiper.params) {
      swiper.params.navigation.prevEl = prevNavRef.current;
      swiper.params.navigation.nextEl = nextNavRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper, prevNavRef, nextNavRef]);

  const NavIcon = navIcon;

  return (
    <div className={cn("flex gap-x-4 pointer-events-none", className)}>
      <Button
        ref={prevNavRef}
        variant="outline"
        size="icon"
        className={cn(
          "bg-primary-bg border-primary-bg-strong rounded-full transition-colors duration-300 pointer-events-auto",
          "disabled:bg-grayscale-weak disabled:border-primary-weak disabled:[&>svg]:text-primary-weak",
          iconClassName
        )}
        data-nav="prev"
      >
        <NavIcon className="size-5" />
      </Button>

      <Button
        ref={nextNavRef}
        variant="outline"
        size="icon"
        className={cn(
          "bg-primary-bg border-primary-bg-strong rounded-full transition-colors duration-300 pointer-events-auto",
          "disabled:bg-grayscale-weak disabled:border-primary-weak disabled:[&>svg]:text-primary-weak",
          iconClassName
        )}
        data-nav="next"
      >
        <NavIcon className="size-5 rotate-180" />
      </Button>
    </div>
  );
}

export default SwiperNav;
